"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _pageLink = babelHelpers.interopRequireDefault(require("./pageLink"));

var PrositeBrandLinkCard =
/*#__PURE__*/
function (_PageLinkCard) {
  babelHelpers.inherits(PrositeBrandLinkCard, _PageLinkCard);

  function PrositeBrandLinkCard() {
    babelHelpers.classCallCheck(this, PrositeBrandLinkCard);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PrositeBrandLinkCard).apply(this, arguments));
  }

  return PrositeBrandLinkCard;
}(_pageLink.default);

exports.default = PrositeBrandLinkCard;